import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Media from 'react-media';
import Menu from '../../../../components/LazyWidgets/Menu';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import style from './QuantQualModule.module.css';
import ReportError from '../ReportError';
import qqModuleHeroCard from './qqComponents/HeroCard/qqModuleHeroCard';
import PerformanceByStudentComponent from '../QuantQual/qqComponents/performanceByStudentComponent';
import PerformanceBySubmodulesComponent from './qqComponents/performanceBySubmodulesComponent';
import performanceByLearningObjectiveComponent from '../QuantQual/qqComponents/performanceByLearningObjectiveComponent';
import PerformanceByAssignmentComponent from '../QuantQual/qqComponents/performanceByAssignmentComponent';
import ReportBreadcrumbs from '../../../../components/ReportBreadcrumbs/ReportBreadcrumbs';
import { REPORT_TYPES } from '../../../actions/constants';
import {
  loadUnitReport as loadUnitReportAction,
  sendAnalyticsEvent,
  updateUnitReport as updateUnitReportAction,
} from '../../../actions/reports';
import ExternalFrameworkCard from '../../../../components/ExternalFrameworkCard';
import { getConfigObject } from '../../../util/config';

class QQModuleReport extends Component {

  constructor(props) {
    super(props);
    this.handleModuleUpdate = this.handleModuleUpdate.bind(this);
    this.containerRef = React.createRef();
    this.adjustDropDowns = this.adjustDropDowns.bind(this);
  }

  componentDidMount() {
    const { course: { id }, loadUnitReport, unitId } = this.props;
    loadUnitReport(id, unitId);
    this.scrollToFragment();
  }

  componentDidUpdate(prevProps) {
    this.adjustDropDowns();
    const { unitId, updateUnitReport } = this.props;
    const prevId = prevProps.unitId;
    if (prevId !== unitId) {
      updateUnitReport(unitId);
    }
  }

  getModalContent() {
    return (
      <div>
        <p><b>Assignments Completed</b> represents the number of assignments the individual students has completed out of the total number of resources assigned to the student in this Unit.<br /></p>
        <p><b>Achievement on completion assignments (practice/homework)</b> represents the proportion of questions in this Unit completed by the student across all assignments in this Unit that define achievement by a student completing the assignment (i.e. practice tests and homework assignments where students are granted multiple attempts per question).<br /></p>
        <p><b>Achievement on proficiency assignments (quizzes/test)</b> represents the proportion of questions in this Unit that a student got correct across all assignments that define achievement by proficiency (i.e. quizzes and test where students are granted only one attempt per question).</p>
      </div>
    );
  }

  scrollToFragment() {
    const hash = window.location.hash;
    if (hash) {
      const element = document.getElementById(hash.substr(1));
      if (element) {
        element.scrollIntoView();
      }
    }
  }

  async handleModuleUpdate(value) {
    const { units, updateUnitReport, onTabChange } = this.props;
    const newActiveUnit = units[value];
    await updateUnitReport(newActiveUnit.id);
    onTabChange(`reports/type/unit/${newActiveUnit.id}`);
  }

  calculateFakeWidth(text) {
    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);
    tempDiv.style.fontSize = '17px';
    tempDiv.style.position = 'absolute';
    tempDiv.style.left = -1000;
    tempDiv.style.top = -1000;
    tempDiv.style['white-space'] = 'nowrap';
    tempDiv.style.lineHeight = '32px';
    tempDiv.innerHTML = text;
    const width = tempDiv.clientWidth;
    document.body.removeChild(tempDiv);
    return width;
  }

  adjustDropDowns() {
    if (this.containerRef.current) {
      const dropDowns = this.containerRef.current.getElementsByTagName('select');
      for (const dropDown of dropDowns) {
        const fakeWidth = this.calculateFakeWidth(dropDown.options[dropDown.selectedIndex].textContent);
        if (fakeWidth > dropDown.offsetWidth + 3) {
          dropDown.parentElement.classList.add(style.ellipsis);
        } else {
          dropDown.parentElement.classList.remove(style.ellipsis);
        }
      }
    }
  }

  render() {
    if (this.props.loading) return <Spinner className={style.qqReportSpinner} />;
    const {
      error,
      unitReport: {
        error: errorReport,
      },
    } = this.props;

    if (error || errorReport) return <ReportError />;

    const {
      onTabChange,
      units,
      unitReport: {
        hasStudents,
        unitHighlights,
        performanceByExternalFrameworks,
        performanceBySubunit,
        performanceByLearningObjective,
        performanceByStudent,
        performanceByAssignment,
      },
      activeUnit,
      course,
      reportType,
    } = this.props;

    const breadcrumbItems = [
      { text: 'Overview', targetUrl: 'reports' },
      { text: (activeUnit) ? activeUnit.name : 'Unit Report' }];

    return (
      <div className={style.qqModuleContainer} ref={this.containerRef}>
        <div className={style.qqModuleTitle}>{activeUnit.name}</div>
        <ReportBreadcrumbs items={breadcrumbItems} onTabChange={onTabChange} />
        <Media query="(max-width: 709px)">
          <Menu
            className={style.qqModuleMenu}
            id="unitId1"
            options={units}
            onChange={this.handleModuleUpdate}
            selectedLabel={activeUnit.name}
            hasLabel
            label="Unit:"
            boxed
          />
        </Media>
        {qqModuleHeroCard({
          unitHighlights,
          onTabChange,
        })}
        {performanceBySubunit && (
          <PerformanceBySubmodulesComponent
            data={performanceBySubunit}
            onTabChange={onTabChange}
            reportType={reportType}
            sendEvent={sendAnalyticsEvent}
          />
        )}
        {performanceByAssignment && (
          <PerformanceByAssignmentComponent
            data={performanceByAssignment}
            courseId={course.id}
            onTabChange={onTabChange}
            reportType={reportType}
            sendEvent={sendAnalyticsEvent}
          />
        )}

        {getConfigObject().FEATURE_USE_EXTERNAL_INSIGHTS && (
          <ExternalFrameworkCard
            reportType={reportType}
            rows={performanceByExternalFrameworks}
          />
        )}

        {performanceByLearningObjective &&
          performanceByLearningObjectiveComponent(
            performanceByLearningObjective,
            hasStudents,
            onTabChange,
            REPORT_TYPES.unit
          )}
        {performanceByStudent && (
          <PerformanceByStudentComponent
            data={performanceByStudent}
            assignments={unitHighlights.assignments}
            onTabChange={onTabChange}
            modalContent={this.getModalContent()}
            buildReportUrl={(studentId) =>
              `reports/type/student-unit/${studentId}/${
                activeUnit ? activeUnit.id : ""
              }`
            }
            reportType={reportType}
            sendEvent={sendAnalyticsEvent}
          />
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    course: state.reports.courseAbstract,
    units: state.reports.unitList.units,
    unitReport: state.reports.unitReport,
    activeUnit: state.reports.unitList.activeUnit,
    loading: !state.reports.unitList.units || state.reports.unitList.loading || !state.reports.unitReport || state.reports.unitReport.loading,
    error: state.reports.unitList.error,
  };
}

const mapDispatchToProps = dispatch => bindActionCreators({
  loadUnitReport: loadUnitReportAction,
  updateUnitReport: updateUnitReportAction,
  sendAnalyticsEvent
}, dispatch);

QQModuleReport.propTypes = {
  unitId: PropTypes.string,
  reportType: PropTypes.string,
  course: PropTypes.object,
  onTabChange: PropTypes.func,
  units: PropTypes.array,
  unitReport: PropTypes.object,
  loadUnitReport: PropTypes.func,
  updateUnitReport: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.any,
  activeUnit: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(QQModuleReport);
